import axios from 'axios';

// 🌐 Адрес API (по умолчанию — локальный сервер)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// 🔑 Устанавливаем токен (если есть)
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const api = {
  // 📊 --- Статистика ---
  getStats: (params) => axios.get(`${API_URL}/stats`, { params }),

  // 👥 --- Клиенты ---
  getClients: () => axios.get(`${API_URL}/clients`),
  createClient: (data) => axios.post(`${API_URL}/clients`, data),
  updateClient: (id, data) => axios.put(`${API_URL}/clients/${id}`, data),
  deleteClient: (id) => axios.delete(`${API_URL}/clients/${id}`),

  // 💇 --- Стрижки ---
  getHaircuts: (params) => axios.get(`${API_URL}/haircuts`, { params }),
  createHaircut: (data) => axios.post(`${API_URL}/haircuts`, data),
  updateHaircut: (id, data) => axios.put(`${API_URL}/haircuts/${id}`, data),
  deleteHaircut: (id) => axios.delete(`${API_URL}/haircuts/${id}`),

  // 💸 --- Расходы ---
  getExpenses: (params) => axios.get(`${API_URL}/expenses`, { params }),
  createExpense: (data) => axios.post(`${API_URL}/expenses`, data),
  updateExpense: (id, data) => axios.put(`${API_URL}/expenses/${id}`, data),
  deleteExpense: (id) => axios.delete(`${API_URL}/expenses/${id}`),

  // 👤 --- Пользователи ---
  getUsers: () => axios.get(`${API_URL}/users`),
  createUser: (data) => axios.post(`${API_URL}/users`, data),
  updateUser: (id, data) => axios.put(`${API_URL}/users/${id}`, data),
  deleteUser: (id) => axios.delete(`${API_URL}/users/${id}`),
};
